import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertBigintToNumber'
})
export class ConvertBigintToNumberPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): number {
    return Number(value.replace(/,/g, ''));
  }

}
